<template>
  <div class="introduction">
    <IntroductionBanner class="introduction-area-banner-area"/>
    <div class="introduction-area">
      <div class="img-area">
        <img src="../assets/images/introduction-1.png"/>
        <div class="img-bottom">
          <img src="../assets/images/introduction-2.png"/>
          <img src="../assets/images/introduction-3.png"/>
        </div>
      </div>
      <div class="text-area">
        <p class="label">公司简介</p>
        <div class="description"> 源于硅谷、扎根中国，上海殷泊信息科技有限公司 (MoPaaS魔泊云) 是中国领先的人工智能(AI) 平台和服务提供商，为用户的数字转型、智能升级和融合创新直接赋能。针对中国AI应用和工程市场的需求，MoPaaS 魔泊云在业界率先推出新一代开放的AI平台为加速客户AI技术创新和应用落地提供高效的GPU算力优化和规模化AI模型开发运维 (ModelOps) 能力和服务。MoPaaS魔泊云 AI平台已经服务在教学科研、工业制造、能源交通、互联网、医疗卫生、政府和金融等行业超过1000家国内外满意的客户的AI技术研发、人才培养和应用落地工程需求。MoPaaS魔泊云致力打造全方位开放的AI技术和应用生态。同时，MoPaaS魔泊云在浙江嘉兴设立安尚云信信息科技有限公司全资子公司，致力于推动当地的科技产业发展，并积极培养本地专业技术人才，创造社会和经济效益。MoPaaS 被Forrester评为中国企业级云平台市场的卓越表现者(Strong Performer)。
</div>
      </div>
    </div>
    <History class="history-area"/>
  </div>
</template>

<script>
  import IntroductionBanner from './IntroductionBanner'
  import History from './History'
	export default {
		name: 'Introduction',
		components: {
      IntroductionBanner,
      History
		},
		data() {
      return {}
		}
	}
</script>

<style>
@media (min-width: 992px) {
  .introduction-area {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 120px 0;
    background: #FFFFFF;
  }
  .introduction-area .img-area {
    margin-right: 104px;
  }
  .introduction-area .img-area .img-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 28px;
  }
  .introduction-area .text-area .label{
    width: 120px;
    height: 42px;
    font-size: 30px;
    font-weight: 500;
    color: #3A3F4D;
    line-height: 42px;
    margin-left: 43px;
  }
  .introduction-area .text-area .description {
    width: 648px;
    height: 380px;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    text-align: left;
    margin-top: 42px;
    text-indent: 2em;
  }
}
  @media (max-width: 992px) {
    .introduction-area-banner-area {
      display: none;
    }
    .history-area {
      display: none;
    }
    .introduction-area {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      /*padding: 6vw;*/
      background: #FFFFFF;
    }
    .introduction-area .img-area {
      margin-right: 104px;
      display: none;
    }
    .introduction-area .img-area .img-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 28px;
    }
    .introduction-area .text-area .label{
      line-height: initial;
      margin-top: 6px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(51, 51, 51, 1);
      font-weight: 500;
      text-align: left;
    }
    .introduction-area .text-area .description {
      text-indent: 2em;
      margin-top: 20px;
      line-height: 1.5;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(132, 132, 132, 1);
      text-align: left;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Introduction.vue